// packages/components/src/doctor-ai/TimelineTab.tsx
import React from 'react';
import { SymptomTimelineChart } from './SymptomTimelineChart';
import type { UIChatMessage, SymptomTimelineData } from '@dopomogai/types';
import { CalendarX2 } from 'lucide-react';

interface TimelineTabProps {
  chatHistory: UIChatMessage[];
}

export const TimelineTab: React.FC<TimelineTabProps> = ({ chatHistory }) => {
  // Find all symptom timeline events and consolidate them
  const allTimelineEvents = chatHistory
    .filter(
      (msg): msg is import('@dopomogai/types').UIToolResponseMessage =>
        msg.type === 'tool_response' && msg.toolName === 'render_symptom_timeline'
    )
    .flatMap(msg => (msg.data as SymptomTimelineData).events);

  // Sort events by date, most recent first
  const sortedEvents = allTimelineEvents.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  const consolidatedTimelineData: SymptomTimelineData = {
    title: 'Patient Event Timeline',
    events: sortedEvents,
  };

  return (
    <div className="p-6 space-y-4">
      <h3 className="text-xl font-bold text-slate-900">Event Timeline</h3>
      {sortedEvents.length > 0 ? (
        <SymptomTimelineChart data={consolidatedTimelineData} />
      ) : (
        <div className="flex flex-col items-center justify-center text-center p-8 bg-slate-100 rounded-xl border-2 border-dashed border-slate-300">
          <CalendarX2 size={40} className="text-slate-400 mb-4" />
          <h4 className="font-semibold text-slate-700">No Timeline Data</h4>
          <p className="text-sm text-slate-500 mt-1 max-w-sm">
            Ask the AI to "chart symptoms" or "create a timeline" to populate this view with key patient events.
          </p>
        </div>
      )}
    </div>
  );
};